import React from "react";
import { getBadgeClassName } from "../../utils/recordMappers";

const badgeBaseClass =
  "inline-flex max-w-full items-center rounded-md px-2.5 py-1 text-[11px] font-semibold tracking-[0.02em]";

const RecordDetailHeader = ({
  datasetLabel,
  detailModel,
  theme,
  isOriginalView,
  isCompanyDetail,
  companyOverview,
  companyHeaderTags,
}) => (
  <div className="relative border-b border-slate-800/90 px-6 py-5">
    <div className="flex items-start justify-between gap-4">
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">
        {isOriginalView ? "Original Document" : "Detail View"}
      </p>
    </div>

    {detailModel ? (
      isCompanyDetail ? (
        <div className="mt-3 space-y-3">
          <div>
            <p className={`text-sm font-medium uppercase tracking-[0.16em] ${theme.accentText}`}>
              {datasetLabel}
            </p>
            <h2 className="mt-2 text-[1.8rem] font-semibold tracking-[-0.03em] text-slate-50">
              {detailModel.title}
            </h2>
          </div>

          <div className="flex flex-wrap items-center gap-2 text-sm">
            <span className="inline-flex items-center rounded-md border border-slate-500/60 bg-slate-900/75 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-100">
              {companyOverview?.assigneeType || "N/A"}
            </span>
            <span className="text-slate-400">
              {companyOverview?.activeSinceYear
                ? `Active since ${companyOverview.activeSinceYear}`
                : "Active since N/A"}
            </span>
            <span className="text-slate-400">
              {`Country: ${companyOverview?.country || "N/A"}`}
            </span>
          </div>

          {companyHeaderTags.length ? (
            <div className="flex flex-wrap gap-2">
              {companyHeaderTags.map((tag) => (
                <span
                  key={`detail-tag-${tag.id}`}
                  className="inline-flex max-w-full items-center rounded-md border border-cyan-400/70 bg-cyan-500/12 px-2.5 py-1 text-[11px] font-semibold tracking-[0.02em] text-cyan-100"
                >
                  {tag.label}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <>
          <p className={`mt-3 text-sm font-medium uppercase tracking-[0.16em] ${theme.accentText}`}>
            {datasetLabel}
          </p>
          <h2 className="mt-2 text-xl font-semibold tracking-[-0.02em] text-slate-50">
            {detailModel.title}
          </h2>
          {detailModel.subtitle ? (
            <p className="mt-2 font-mono text-xs text-slate-500">{detailModel.subtitle}</p>
          ) : null}
          {detailModel.meta.length ? (
            <div className="mt-4 flex flex-wrap gap-2">
              {detailModel.meta.map((item) => (
                <span
                  key={`${item.label}-${item.value}`}
                  className={`${badgeBaseClass} ${getBadgeClassName(item.kind, item.value, theme)}`}
                >
                  {item.value}
                </span>
              ))}
            </div>
          ) : null}
        </>
      )
    ) : (
      <div className="mt-6 rounded-2xl border border-dashed border-slate-700 bg-slate-950/50 px-4 py-10 text-center text-sm text-slate-400">
        Select a record to open the detail card.
      </div>
    )}
  </div>
);

export default RecordDetailHeader;
